import Http from '../util/httpUtils'
import axios from 'axios'
import { CHANNEL } from '../constants/conf'
import initUrl from '../util/initUrl'

let urlTemplate = null;
let isHdmap = true;


function wrapAxios(promise) {
  if (isHdmap) {
    return promise.then(
      res => {
        return promise;
      },
      error => {
        console.log(error.response.status);
        if (error.response.status === 403) {
          localStorage.removeItem('ACCESS_TOKEN');
          localStorage.removeItem('SESSION_ID');
          localStorage.removeItem('__USER__');
          window.location.href = '/'
        }
        return promise;
      }
    )
  } else {
    return promise;
  }
}



export default {
  /**
  * 初始化平台判定(标注平台 or hdmap)
  */
  initPlatform: function (bool) {
    isHdmap = bool;
    if (isHdmap && process.env.CHANNEL !== "offline" && window.OVERRIDE_SKIP_LDAP !== true) {
      const ACCESS_TOKEN = localStorage.getItem('ACCESS_TOKEN') ? localStorage.getItem('ACCESS_TOKEN') : '';
      const SESSION_ID = localStorage.getItem('SESSION_ID') ? localStorage.getItem('SESSION_ID') : '';
      //header包裹
      axios.defaults.headers.common['access_token'] = ACCESS_TOKEN;
      axios.defaults.headers.common['sessionid'] = SESSION_ID;
    }
  },


  /**
  * 获取 urlTemplate
  */
  getUrlTemplate() {
    if (process.env.CHANNEL === "offline") {
      return wrapAxios(axios.get(`${CHANNEL}/requesttemplate.json`));
    } else {
      // Template url for local override
      if (window.OVERRIDE_TEMPLATE_URL) {
        console.log("found override template url: " + window.OVERRIDE_TEMPLATE_URL);
        return wrapAxios(axios.get(window.OVERRIDE_TEMPLATE_URL));  
      }
      return wrapAxios(axios.get(`${CHANNEL}/hdmap/requesttemplate?product=${process.env.CHANNEL}`));
    }
  },

  urlTemplateResult(result) {
    urlTemplate = result;
  },

  uiUrlTemplate() {
    return urlTemplate;
  },

  /**
   * 使用缓存
   * @returns {*}
   */
  getHttpDataWithCache: function () {
    return Http.get(CHANNEL + '/api/data/groups', {}, {
      store: sessionStorage,
      fromCache: true,
      key: ['data_groups'].join('_'),
      expire: 3600 // 1小时
    });
  },
  /**
   * 带参数
   * @param groupId
   * @returns {*}
   */
  getHttpDataWithoutCache: function (groupId) {
    return Http.get(CHANNEL + '/api/data/group/:groupId/sources', { groupId: groupId });
  },
  /**
   * 本地mock数据
   * @returns {*}
   */
  getFromMockData: function () {
    return Http.get('./mock/demo.json');
  },

  


  /**
  * 登录
  */
  login: function(params,firstLogin) {
    if (firstLogin) {
      return axios.post(`${CHANNEL}/hdmap/login`, params);
    }
    return wrapAxios(axios.post(`${CHANNEL}/hdmap/login`, params));
  },


  /*
  * 获取regionList数据
  */
  getRegionListData: function () {
    // return axios.get(`${CHANNEL}/hdmap/layout?mapver=${window.mapver}`)
    
    if (process.env.CHANNEL === "offline") {
      return axios.get(`${CHANNEL}/region.json`);
    } else {
      // const ACCESS_TOKEN = localStorage.getItem('ACCESS_TOKEN');
      // const SESSION_ID = localStorage.getItem('SESSION_ID');

      // Region url for local override
      if (window.OVERRIDE_REGION_URL) {
        console.log("found override region url: " + window.OVERRIDE_REGION_URL);
        return wrapAxios(axios.get(window.OVERRIDE_REGION_URL));  
      }
      return wrapAxios(axios.get(`${CHANNEL}/hdmap/region`));
    }
  },

  /**
  * 获取currentRegion data信息
  */
  getCurrentRegionData: function (region) {
    let metadataUrl = urlTemplate.requesttemplate.metadata.baseurl;
    metadataUrl = initUrl(metadataUrl, { regionid: region, mapver: window.mapver });
    return wrapAxios(axios.get(metadataUrl));
  },

  /**
   * 获取指定S2 Cell的采集车轨迹数据
   */
  getTrajectoryForCell: function (region, cellId) {
    let reqUrl = urlTemplate.requesttemplate.traj.baseurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver
    });
    return wrapAxios(axios.get(reqUrl));
  },

  /**
   * 获取指定S2 Cell的采集车轨迹数据 local wkb ver
   */
  getLocalTrajectoryForCell: function (region, cellId) {
    let reqUrl = urlTemplate.requesttemplate.traj.baseurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver
    });
    return wrapAxios(axios.get(reqUrl, {
          responseType: 'arraybuffer'
        }));
  },

  /**
   * 获取region的全部ccd
   */
  getRegionCcd: function (regionid) {
    let reqUrl = urlTemplate.requesttemplate.ccd.ccdpoints;
    reqUrl = initUrl(reqUrl, {regionid});
    return wrapAxios(axios.get(reqUrl));
  },

  /**
   * 获取指定CCD点的指定图片的URL
   */
  getCCDImageURL: function (params) {
    const { regionid, trajectoryid, ccd_index, camera_index, type } = params;
    let reqUrl = urlTemplate.requesttemplate.ccd.ccdinfo;
    reqUrl = initUrl(reqUrl, {
      regionid,
      trajectoryid,
      ccd_index,
      camera_index,
      type
    });
    return reqUrl;
  },
  /**
   * 获取实时轨迹URL
   */
  getRealTimeTrajURL: function () {
    return urlTemplate.requesttemplate.realtimetraj.baseurl;
  },

  /**
   * 获取指定S2 Cell的全部标注数据
   */
  getMarkersForCell: function (region, cellId) {
    // DONE: 临时解决快速修改操作后get标注有可能被cache hit的问题
    // 20181025 已修改为模板URL，重定向到不带cache的URL，所以去掉了timestamp参数
    let reqUrl = urlTemplate.requesttemplate.marks.readurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver
    });

    return wrapAxios(axios.get(reqUrl));
  },

  /**
   * 保存标注
   */
  saveMarkers: function (region, markersData, cellId) {
    let reqUrl = urlTemplate.requesttemplate.marks.writeurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver
    });
    return wrapAxios(axios.post(reqUrl,
          markersData));
  },

  /**
   * 删除指定S2 Cell的全部标注数据
   */
  deleteMarkersForCell: function (region, cellId) {
    let reqUrl = urlTemplate.requesttemplate.marks.deleteurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver
    });
    return wrapAxios(axios.delete(reqUrl));
  },

  /**
   * 删除指定S2 Cell的指定ID标注数据
   */
  deleteMarker: function (region, cellId, markerId) {
    let reqUrl = urlTemplate.requesttemplate.marks.deleteuuidurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      uuid: markerId,
      mapver: window.mapver
    });
    return wrapAxios(axios.delete(reqUrl));
  },

  /**
   * 根据选中link(有顺序)生成车道线
   */
  genLaneMarkers: function (region, markersData, cellId) {
    let reqUrl = urlTemplate.requesttemplate.marks.writeurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver,
    });
    return wrapAxios(axios.put(reqUrl,
          markersData));
  },

  /**
   * 根据选中lane(有顺序)生成车道线
   */
  genRoadMarkers: function (region, markersData, cellId) {
    let reqUrl = urlTemplate.requesttemplate.marks.writeurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver,
    });
    return wrapAxios(axios.put(reqUrl,
          markersData));
  },

  /**
   * 根据选中路口区域、入口道路、出口道路生成道路连接线及填充路口区域关联属性
   */
  genInterRoadMarkers: function (region, markersData, cellId) {
    let reqUrl = urlTemplate.requesttemplate.marks.writeurl;
    reqUrl = initUrl(reqUrl, {
      regionid: region,
      tileid: cellId,
      mapver: window.mapver,
    });
    return wrapAxios(axios.put(reqUrl,
          markersData));
  },


  
}



// WEBPACK FOOTER //
// ./src/data/demo.js